// extracted by mini-css-extract-plugin
export default {"hovertext":"payments_hovertext__XdOaO"};